import SectionHeading from "./SectionHeading";
import NewsTimeline from "./NewsTimeline";
import HotRanking from "./HotRanking";

const guidelines = [
  "描述事实，标注信息来源",
  "区分“我看到的”和“我猜的”",
  "可以反驳观点，但别针对个人",
];

export default function LiveSection() {
  return (
    <section id="live" className="bg-background-50 scroll-mt-20">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="Live Feed"
            title="实时快讯流"
            description="按发生顺序整理每一条讨论线索。短讯与卡片并行，信息密度高，你可以快速扫读，也可以逐条展开细看。"
          />
          <a
            href="#subscribe"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-notification-3-line" />
            订阅更新提醒
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <div className="lg:col-span-2">
            <NewsTimeline />
          </div>

          <aside className="flex flex-col gap-6">
            <HotRanking />

            <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                参与讨论的小提示
              </h3>
              <ul className="mt-4 space-y-3">
                {guidelines.map((tip, index) => (
                  <li key={tip} className="flex items-start gap-3">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-bold text-secondary-800">
                      {index + 1}
                    </span>
                    <span className="text-sm leading-relaxed text-foreground-700">{tip}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#voices"
                className="mt-5 flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
              >
                去看网友观点
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}